import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientEditInputPage } from '@/feature/hotline/client/create/input/page/HotlineClientEditInputPage';
/**
 * 匿名ホットライン編集 入力
 */
export const HotlineClientEditInput = () => _jsx(HotlineClientEditInputPage, {});
